import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import getFetchCartOptions from "../fetch/get-options";
import trackEvent from "../../../../../analytics/track-event";
import getProductFeedThreadsQueryKey from "../../../../product-feed-threads/v2/get-query-key";
import patchCart from "../api-calls/patch-cart";
import updateCartReviewsTotals from "../utils/update-cart-reviews-totals";
import getCartQueryKey from "../get-query-key";
import getCartReviewsQueryKey from "../../../cart_reviews/v2/get-query-key";
import getPartnerCartReviewsQueryKey from "../../../partner_cart_reviews/v1/get-query-key";
import getPartnerCartReviewsV2QueryKey from "../../../partner_cart_reviews/v2/get-query-key";
import handleCartWarnings from "../utils/handle-warnings";
import { activeUpdateRequests } from "../utils/active-update-requests";
var removeCartItem = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var id;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          id = _ref.id;
          return _context.abrupt("return", patchCart({
            actions: [{
              op: 'remove',
              path: '/items',
              value: {
                id: id
              }
            }]
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function removeCartItem(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var getRemoveItemOptions = function getRemoveItemOptions(_ref3) {
  var queryClient = _ref3.queryClient;
  return {
    mutationFn: function mutationFn(_ref4) {
      var id = _ref4.id;
      return removeCartItem({
        id: id
      });
    },
    onMutate: function () {
      var _onMutate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref5) {
        var id, cartQueryKey, currentCart, removedItem;
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              id = _ref5.id;
              cartQueryKey = getCartQueryKey();
              currentCart = queryClient.getQueryData(cartQueryKey);
              removedItem = currentCart === null || currentCart === void 0 ? void 0 : currentCart.items.find(function (item) {
                return item.id === id;
              });
              if (activeUpdateRequests.has(id)) {
                activeUpdateRequests.get(id).abort();
                activeUpdateRequests["delete"](id);
              }
              _context2.next = 1;
              return Promise.all([queryClient.cancelQueries({
                queryKey: getCartReviewsQueryKey()
              }), queryClient.cancelQueries({
                queryKey: getPartnerCartReviewsQueryKey()
              }), queryClient.cancelQueries({
                queryKey: getPartnerCartReviewsV2QueryKey()
              })]);
            case 1:
              // optimistically remove item from 'carts'
              queryClient.setQueryData(cartQueryKey, function (currentCart) {
                return _objectSpread(_objectSpread({}, currentCart), {}, {
                  items: currentCart === null || currentCart === void 0 ? void 0 : currentCart.items.filter(function (item) {
                    return item.id !== id;
                  })
                });
              });
              _context2.next = 2;
              return updateCartReviewsTotals({
                queryClient: queryClient
              });
            case 2:
              return _context2.abrupt("return", {
                removedItem: removedItem,
                meta: {
                  dispatchCartUpdated: true,
                  dispatchCartCountUpdated: true
                }
              });
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function onMutate(_x2) {
        return _onMutate.apply(this, arguments);
      }
      return onMutate;
    }(),
    onSuccess: function () {
      var _onSuccess = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(data, variables, context) {
        var _ref6, quantity, productId, skuId, productCode, gtin, priceInfo, _yield$Promise$all, _yield$Promise$all2, cart, CurrencyEnums, cartId, currency, productFeedData, pid, category, brand, styleColor, content, productName, activeRemoveItemMutations;
        return _regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _ref6 = (context === null || context === void 0 ? void 0 : context.removedItem) || {}, quantity = _ref6.quantity, productId = _ref6.productId, skuId = _ref6.skuId, productCode = _ref6.productCode, gtin = _ref6.gtin, priceInfo = _ref6.priceInfo;
              _context3.next = 1;
              return Promise.all([queryClient.fetchQuery(getFetchCartOptions({
                queryClient: queryClient
              })), window.webShellClient.analytics.utils.getProtoEnums('Currency')]);
            case 1:
              _yield$Promise$all = _context3.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              cart = _yield$Promise$all2[0];
              CurrencyEnums = _yield$Promise$all2[1];
              cartId = cart === null || cart === void 0 ? void 0 : cart.id;
              currency = cart === null || cart === void 0 ? void 0 : cart.currency;
              window.webShellClient.analytics.trackAction({
                underlyingAction: {
                  "case": 'coreCommerceV1CartModified',
                  value: {
                    cartId: cartId,
                    operation: {
                      "case": 'itemRemoved',
                      value: {
                        product: {
                          "case": 'consumerProduct',
                          value: {
                            productCode: {
                              value: productCode
                            },
                            gtin: {
                              value: gtin
                            }
                          }
                        },
                        currency: CurrencyEnums[currency === null || currency === void 0 ? void 0 : currency.toUpperCase()],
                        fullPriceTotal: window.webShellClient.analytics.utils.toUnitsNanos(priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.fullPriceTotal),
                        currentPriceTotal: window.webShellClient.analytics.utils.toUnitsNanos(priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.total),
                        quantity: quantity
                      }
                    }
                  }
                }
              });
              productFeedData = queryClient.getQueryData(getProductFeedThreadsQueryKey({
                productId: productId,
                styleColor: productCode
              })) || {};
              pid = productFeedData.pid, category = productFeedData.productType, brand = productFeedData.brand, styleColor = productFeedData.styleColor, content = productFeedData.content;
              productName = content === null || content === void 0 ? void 0 : content.title;
              trackEvent('Product Removed', {
                brand: brand,
                cartId: cartId,
                category: category,
                cloudProductId: productId,
                currency: currency,
                name: productName,
                price: priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.total,
                prodigyProductId: pid,
                productId: pid,
                quantity: quantity,
                sku: skuId,
                styleColor: styleColor
              }, {
                telemetryData: {
                  cartId: cartId,
                  productCode: productCode,
                  gtin: gtin,
                  quantity: quantity,
                  currency: currency
                },
                usePageAction: true
              });

              // Check for other active remove item mutations
              activeRemoveItemMutations = queryClient.getMutationCache().getAll().filter(function (mutation) {
                return mutation.state.status === 'pending' && mutation.options.mutationFn === removeCartItem;
              }); // Only update cache if this is the last removal mutation
              if (!(activeRemoveItemMutations.length === 0)) {
                _context3.next = 5;
                break;
              }
              queryClient.setQueryData(getCartQueryKey(), data);
              _context3.next = 2;
              return queryClient.invalidateQueries({
                queryKey: getCartReviewsQueryKey()
              });
            case 2:
              _context3.next = 3;
              return queryClient.invalidateQueries({
                queryKey: getPartnerCartReviewsQueryKey()
              });
            case 3:
              _context3.next = 4;
              return queryClient.invalidateQueries({
                queryKey: getPartnerCartReviewsV2QueryKey()
              });
            case 4:
              if (!(data !== null && data !== void 0 && data.warnings && data.warnings.length > 0)) {
                _context3.next = 5;
                break;
              }
              _context3.next = 5;
              return handleCartWarnings({
                warnings: data.warnings,
                data: data
              }, queryClient);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function onSuccess(_x3, _x4, _x5) {
        return _onSuccess.apply(this, arguments);
      }
      return onSuccess;
    }()
  };
};
export default getRemoveItemOptions;